// import React, { useEffect, useState } from "react";
// import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner, Card } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import api from "../../api";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./FormExecutionReportsPage.css";

// // Phase 3D, §32/§33/§34. A GENERIC report over any TEST_EXECUTION-profiled
// // form version (UAT or TESTING) — not a UAT-only page, and every number
// // shown is a straight read of the stored `form_submission_test_summaries`
// // snapshot per submission revision (never a live recomputation over
// // historical data). Same list/filter/pagination shape as
// // FormReviewQueuePage.jsx.
// function useRolePrefix() {
//   const path = window.location.pathname;
//   const match = path.match(/^\/([^/]+)\//);
//   return match ? match[1] : "admin";
// }

// const RESULT_FILTERS = [
//   { key: "", label: "All Results" },
//   { key: "failed", label: "Has Failures" },
//   { key: "blocked", label: "Has Blocked" },
//   { key: "all_passed", label: "All Passed" },
// ];

// export default function FormExecutionReportsPage() {
//   const navigate = useNavigate();
//   const rolePrefix = useRolePrefix();

//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [formTypeFilter, setFormTypeFilter] = useState("");
//   const [projectFilter, setProjectFilter] = useState("");
//   const [resultFilter, setResultFilter] = useState("");
//   const [reviewStatusFilter, setReviewStatusFilter] = useState("");
//   const [search, setSearch] = useState("");
//   const [formTypes, setFormTypes] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 20;

//   const [showFailedCases, setShowFailedCases] = useState(false);
//   const [failedCases, setFailedCases] = useState([]);
//   const [loadingFailedCases, setLoadingFailedCases] = useState(false);

//   const buildFilterParams = () => ({
//     form_type_id: formTypeFilter || undefined,
//     project_id: projectFilter || undefined,
//     result: resultFilter || undefined,
//     review_status: reviewStatusFilter || undefined,
//     search: search || undefined,
//   });

//   const fetchReports = async () => {
//     try {
//       setLoading(true);
//       const [listRes, summaryRes] = await Promise.all([
//         api.get("/form-execution-reports", { params: { ...buildFilterParams(), page: currentPage, pageSize } }),
//         api.get("/form-execution-reports/summary", { params: buildFilterParams() }),
//       ]);
//       setRows(Array.isArray(listRes.data?.data) ? listRes.data.data : []);
//       setTotal(listRes.data?.meta?.total || 0);
//       setSummary(summaryRes.data?.data || null);
//     } catch (err) {
//       console.error("Fetch execution reports error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch execution reports");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReports();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [formTypeFilter, projectFilter, resultFilter, reviewStatusFilter, search, currentPage]);

//   useEffect(() => {
//     Promise.all([
//       api.get("/form-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//       api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//     ]).then(([typeRes, projectRes]) => {
//       setFormTypes(Array.isArray(typeRes?.data?.data) ? typeRes.data.data : []);
//       setProjects(Array.isArray(projectRes?.data?.data) ? projectRes.data.data : []);
//     });
//   }, []);

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const loadFailedCases = async () => {
//     if (showFailedCases) { setShowFailedCases(false); return; }
//     setShowFailedCases(true);
//     setLoadingFailedCases(true);
//     try {
//       const res = await api.get("/form-execution-reports/failed-cases", { params: buildFilterParams() });
//       setFailedCases(Array.isArray(res.data?.data) ? res.data.data : []);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load failed cases");
//       setFailedCases([]);
//     } finally {
//       setLoadingFailedCases(false);
//     }
//   };

//   return (
//     <div className="unit-page formexecreports-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Forms</div>
//           <h2>Form Execution Reports</h2>
//           <p>Test-execution results across all UAT/testing-profiled form submissions — pass rate, failures, and linked defect tasks.</p>
//         </div>
//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchReports}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>
//         </div>
//       </div>

//       {summary && (
//         <Card className="mb-3 fer-summary-card">
//           <Card.Body>
//             <div className="d-flex flex-wrap gap-2 small">
//               <Badge bg="light" text="dark">Submissions: {summary.submission_count}</Badge>
//               <Badge bg="light" text="dark">Total Cases: {summary.total_test_cases}</Badge>
//               <Badge bg="success">Passed: {summary.passed_test_cases}</Badge>
//               <Badge bg="danger">Failed: {summary.failed_test_cases}</Badge>
//               <Badge bg="warning" text="dark">Blocked: {summary.blocked_test_cases}</Badge>
//               <Badge bg="secondary">N/A: {summary.not_applicable_test_cases}</Badge>
//               <Badge bg="info" text="dark">Avg Pass Rate: {summary.pass_rate != null ? `${summary.pass_rate}%` : "—"}</Badge>
//               <Badge bg="info" text="dark">Avg Completion: {summary.completion_rate != null ? `${summary.completion_rate}%` : "—"}</Badge>
//               <Badge bg="dark">Defect Tasks: {summary.defects_created}</Badge>
//               <Badge bg="warning" text="dark">Open Tasks: {summary.open_linked_tasks}</Badge>
//               <Badge bg="success">Closed Tasks: {summary.closed_linked_tasks}</Badge>
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       <div className="unit-card">
//         <div className="unit-toolbar" style={{ flexWrap: "wrap", gap: 8 }}>
//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control placeholder="Search..." aria-label="Search execution reports" value={search} onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }} />
//             </InputGroup>
//             <Form.Select style={{ maxWidth: 170 }} value={formTypeFilter} onChange={(e) => { setCurrentPage(1); setFormTypeFilter(e.target.value); }}>
//               <option value="">All Form Types</option>
//               {formTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={projectFilter} onChange={(e) => { setCurrentPage(1); setProjectFilter(e.target.value); }}>
//               <option value="">All Projects</option>
//               {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={resultFilter} onChange={(e) => { setCurrentPage(1); setResultFilter(e.target.value); }}>
//               {RESULT_FILTERS.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={reviewStatusFilter} onChange={(e) => { setCurrentPage(1); setReviewStatusFilter(e.target.value); }}>
//               <option value="">All Review Statuses</option>
//               <option value="PENDING">Pending</option>
//               <option value="APPROVED">Approved</option>
//               <option value="REJECTED">Rejected</option>
//               <option value="CHANGES_REQUESTED">Changes Requested</option>
//             </Form.Select>
//             <Button size="sm" variant={showFailedCases ? "primary" : "outline-secondary"} className="fer-toggle-btn" onClick={loadFailedCases}>
//               <i className={`fa-solid ${showFailedCases ? "fa-eye-slash" : "fa-eye"}`} aria-hidden="true"></i>
//               {showFailedCases ? "Hide Failed Cases" : "View Failed Cases"}
//             </Button>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader"><Spinner animation="border" /><p>Loading execution reports...</p></div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th>Form</th>
//                   <th>Employee</th>
//                   <th>Scope</th>
//                   <th>Submitted</th>
//                   <th>Review Status</th>
//                   <th>Cases (P/F/B/NA)</th>
//                   <th>Pass Rate</th>
//                   <th>Completion</th>
//                   <th>Linked Tasks</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.length > 0 ? rows.map((row) => (
//                   <tr key={`${row.form_submission_id}-${row.submission_revision}`}>
//                     <td>
//                       {row.form_name} <span className="text-muted small">v{row.version_number}</span><br />
//                       <Badge bg="light" text="dark">{row.form_type_name}</Badge>
//                     </td>
//                     <td className="small">{row.employee_name}</td>
//                     <td className="small text-muted">{row.project_name || "—"}{row.module_name ? ` / ${row.module_name}` : ""}</td>
//                     <td className="small">{row.submitted_at ? new Date(row.submitted_at).toLocaleString() : "—"}</td>
//                     <td><Badge bg="light" text="dark">{row.review_status || "—"}</Badge></td>
//                     <td className="small">
//                       <Badge bg="success" className="me-1">{row.passed_test_cases}</Badge>
//                       <Badge bg="danger" className="me-1">{row.failed_test_cases}</Badge>
//                       <Badge bg="warning" text="dark" className="me-1">{row.blocked_test_cases}</Badge>
//                       <Badge bg="secondary">{row.not_applicable_test_cases}</Badge>
//                     </td>
//                     <td className="small">{row.pass_rate != null ? `${row.pass_rate}%` : "—"}</td>
//                     <td className="small">{row.completion_rate != null ? `${row.completion_rate}%` : "—"}</td>
//                     <td className="small">{row.active_linked_task_count} active / {row.linked_task_count} total</td>
//                     <td className="text-end">
//                       <Button size="sm" variant="outline-primary" className="fer-view-btn" onClick={() => navigate(`/${rolePrefix}/form-submissions/${row.form_submission_id}`)}>
//                         <i className="fa-solid fa-eye" aria-hidden="true"></i>
//                         View
//                       </Button>
//                     </td>
//                   </tr>
//                 )) : (
//                   <tr>
//                     <td colSpan="10">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-flask-vial" aria-hidden="true"></i>
//                         </div>
//                         <h5>No execution results found</h5>
//                         <p>No test-execution-profiled submissions match the selected filters.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> item(s)</div>
//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       {showFailedCases && (
//         <Card className="mt-3 fer-cases-card">
//           <Card.Body>
//             <strong className="small d-block mb-2">Failed / Blocked Test Cases (current filters)</strong>
//             {loadingFailedCases ? (
//               <Spinner size="sm" animation="border" />
//             ) : (
//               <Table size="sm" responsive className="unit-table fer-cases-table">
//                 <thead>
//                   <tr>
//                     <th>Form</th><th>Employee</th><th>#</th><th>Test Case</th><th>Result</th><th>Severity</th><th>Expected</th><th>Actual</th><th></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {failedCases.map((row, i) => (
//                     <tr key={`${row.form_submission_id}-${row.id}-${i}`}>
//                       <td className="small">{row.form_name}</td>
//                       <td className="small">{row.employee_name}</td>
//                       <td>{row.row_number}</td>
//                       <td className="small">{row.test_case_id || row.test_case_title || "—"}</td>
//                       <td><Badge bg={row.result_status === "FAIL" ? "danger" : "warning"} text={row.result_status === "FAIL" ? undefined : "dark"}>{row.result_status}</Badge></td>
//                       <td className="small">{row.severity || "—"}</td>
//                       <td className="small" style={{ maxWidth: 160 }}>{row.expected_result || "—"}</td>
//                       <td className="small" style={{ maxWidth: 160 }}>{row.actual_result || "—"}</td>
//                       <td>
//                         <Button size="sm" variant="outline-primary" className="fer-view-btn" onClick={() => navigate(`/${rolePrefix}/form-submissions/${row.form_submission_id}`)}>
//                           <i className="fa-solid fa-eye" aria-hidden="true"></i>
//                           View
//                         </Button>
//                       </td>
//                     </tr>
//                   ))}
//                   {!failedCases.length && <tr><td colSpan="9" className="text-muted small">No failed/blocked cases for the selected filters.</td></tr>}
//                 </tbody>
//               </Table>
//             )}
//           </Card.Body>
//         </Card>
//       )}
//     </div>
//   );
// }





import React, { useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { toast } from "react-toastify";
import { initialsOf, avatarColorFor } from "../../utils/avatar";
import ExternalRecipientBadge, { isExternalRecipient } from "../../components/forms/ExternalRecipientBadge";
import "./FormExecutionReportsPage.css";

// Restyle only -- REAL review_status enum values (PENDING/APPROVED/
// REJECTED/CHANGES_REQUESTED), same pastel-pill tone convention used
// elsewhere in the Forms Workspace.
const REVIEW_TONE = { PENDING: "warning", APPROVED: "success", REJECTED: "danger", CHANGES_REQUESTED: "warning" };

// Phase 3D, §32/§33/§34. A GENERIC report over any TEST_EXECUTION-profiled
// form version (UAT or TESTING) — not a UAT-only page, and every number
// shown is a straight read of the stored `form_submission_test_summaries`
// snapshot per submission revision (never a live recomputation over
// historical data). Same list/filter/pagination shape as
// FormReviewQueuePage.jsx.
function useRolePrefix() {
  const path = window.location.pathname;
  const match = path.match(/^\/([^/]+)\//);
  return match ? match[1] : "admin";
}

const RESULT_FILTERS = [
  { key: "", label: "All Results" },
  { key: "failed", label: "Has Failures" },
  { key: "blocked", label: "Has Blocked" },
  { key: "all_passed", label: "All Passed" },
];

export default function FormExecutionReportsPage({ embedded = false } = {}) {
  const navigate = useNavigate();
  const rolePrefix = useRolePrefix();

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formTypeFilter, setFormTypeFilter] = useState("");
  const [projectFilter, setProjectFilter] = useState("");
  const [resultFilter, setResultFilter] = useState("");
  const [reviewStatusFilter, setReviewStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [formTypes, setFormTypes] = useState([]);
  const [projects, setProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const [showFailedCases, setShowFailedCases] = useState(false);
  const [failedCases, setFailedCases] = useState([]);
  const [loadingFailedCases, setLoadingFailedCases] = useState(false);
  const [showMoreMetrics, setShowMoreMetrics] = useState(false);

  const buildFilterParams = () => ({
    form_type_id: formTypeFilter || undefined,
    project_id: projectFilter || undefined,
    result: resultFilter || undefined,
    review_status: reviewStatusFilter || undefined,
    search: search || undefined,
  });

  const fetchReports = async () => {
    try {
      setLoading(true);
      const [listRes, summaryRes] = await Promise.all([
        api.get("/form-execution-reports", { params: { ...buildFilterParams(), page: currentPage, pageSize } }),
        api.get("/form-execution-reports/summary", { params: buildFilterParams() }),
      ]);
      setRows(Array.isArray(listRes.data?.data) ? listRes.data.data : []);
      setTotal(listRes.data?.meta?.total || 0);
      setSummary(summaryRes.data?.data || null);
    } catch (err) {
      console.error("Fetch execution reports error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch execution reports");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formTypeFilter, projectFilter, resultFilter, reviewStatusFilter, search, currentPage]);

  useEffect(() => {
    Promise.all([
      api.get("/form-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
      api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
    ]).then(([typeRes, projectRes]) => {
      setFormTypes(Array.isArray(typeRes?.data?.data) ? typeRes.data.data : []);
      setProjects(Array.isArray(projectRes?.data?.data) ? projectRes.data.data : []);
    });
  }, []);

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const loadFailedCases = async () => {
    if (showFailedCases) { setShowFailedCases(false); return; }
    setShowFailedCases(true);
    setLoadingFailedCases(true);
    try {
      const res = await api.get("/form-execution-reports/failed-cases", { params: buildFilterParams() });
      setFailedCases(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load failed cases");
      setFailedCases([]);
    } finally {
      setLoadingFailedCases(false);
    }
  };

  return (
    <div className={`unit-page formexecreports-theme ${embedded ? "fa-embedded" : ""}`}>

      <div className="unit-header">
        {!embedded && (
          <div>
            <div className="unit-page-label">Forms</div>
            <h2>Form Execution Reports</h2>
            <p>Test-execution results across all UAT/testing-profiled form submissions — pass rate, failures, and linked defect tasks.</p>
          </div>
        )}
        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchReports}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>
        </div>
      </div>

      {summary && (
        <Card className="mb-3 fer-summary-card exec-summary-card">
          <Card.Body>
            {/* 4 primary KPIs per the Forms Workspace consolidation --
                the other 7 metrics move behind "More Metrics" so this
                card stays scannable at a glance. */}
            <div className="fer-kpi-row">
              <div className="fer-kpi-card">
                <span className="fer-kpi-label">Submissions</span>
                <strong className="fer-kpi-value">{summary.submission_count}</strong>
              </div>
              <div className="fer-kpi-card">
                <span className="fer-kpi-label">Pass Rate</span>
                <strong className="fer-kpi-value text-success">{summary.pass_rate != null ? `${summary.pass_rate}%` : "—"}</strong>
              </div>
              <div className="fer-kpi-card">
                <span className="fer-kpi-label">Failed Cases</span>
                <strong className="fer-kpi-value text-danger">{summary.failed_test_cases}</strong>
              </div>
              <div className="fer-kpi-card">
                <span className="fer-kpi-label">Open Defects</span>
                <strong className="fer-kpi-value text-warning">{summary.open_linked_tasks}</strong>
              </div>
            </div>
            <Button
              size="sm"
              variant="link"
              className="fer-more-metrics-toggle p-0 mt-2"
              onClick={() => setShowMoreMetrics((v) => !v)}
            >
              <i className={`fa-solid ${showMoreMetrics ? "fa-chevron-up" : "fa-chevron-down"}`} aria-hidden="true"></i>
              {showMoreMetrics ? "Hide More Metrics" : "More Metrics"}
            </Button>
            {showMoreMetrics && (
              <div className="d-flex flex-wrap gap-2 small mt-2">
                <Badge bg="light" text="dark">Total Cases: {summary.total_test_cases}</Badge>
                <Badge bg="success">Passed: {summary.passed_test_cases}</Badge>
                <Badge bg="warning" text="dark">Blocked: {summary.blocked_test_cases}</Badge>
                <Badge bg="secondary">N/A: {summary.not_applicable_test_cases}</Badge>
                <Badge bg="info" text="dark">Avg Completion: {summary.completion_rate != null ? `${summary.completion_rate}%` : "—"}</Badge>
                <Badge bg="dark">Defect Tasks: {summary.defects_created}</Badge>
                <Badge bg="success">Closed Tasks: {summary.closed_linked_tasks}</Badge>
              </div>
            )}
          </Card.Body>
        </Card>
      )}

      <div className="unit-card">
        <div className="unit-toolbar exec-report-toolbar">
          <div className="exec-report-section-title">
            <div className="exec-report-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="exec-report-section-copy">
              <h5>Execution Results</h5>
              <p>
                Filter test-execution submissions and inspect pass, failure,
                completion and linked-task metrics.
              </p>
            </div>
          </div>

          <div className="unit-toolbar-actions exec-report-filters-row">
            <InputGroup className="unit-search exec-report-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search..."
                aria-label="Search execution reports"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="exec-report-clear-search"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>
            <Form.Select style={{ maxWidth: 170 }} value={formTypeFilter} onChange={(e) => { setCurrentPage(1); setFormTypeFilter(e.target.value); }}>
              <option value="">All Form Types</option>
              {formTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </Form.Select>
            <Form.Select style={{ maxWidth: 170 }} value={projectFilter} onChange={(e) => { setCurrentPage(1); setProjectFilter(e.target.value); }}>
              <option value="">All Projects</option>
              {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </Form.Select>
            <Form.Select style={{ maxWidth: 170 }} value={resultFilter} onChange={(e) => { setCurrentPage(1); setResultFilter(e.target.value); }}>
              {RESULT_FILTERS.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
            </Form.Select>
            <Form.Select style={{ maxWidth: 170 }} value={reviewStatusFilter} onChange={(e) => { setCurrentPage(1); setReviewStatusFilter(e.target.value); }}>
              <option value="">All Review Statuses</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Approved</option>
              <option value="REJECTED">Rejected</option>
              <option value="CHANGES_REQUESTED">Changes Requested</option>
            </Form.Select>
            <button
              type="button"
              className={`fer-failed-cases-chip ${showFailedCases ? "active" : ""}`}
              onClick={loadFailedCases}
            >
              <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
              Failed Cases {summary ? `(${summary.failed_test_cases})` : ""}
            </button>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader"><Spinner animation="border" /><p>Loading execution reports...</p></div>
          ) : (
            <Table responsive className="unit-table fer-table-v2">
              <thead>
                <tr>
                  <th>Form</th>
                  <th>Employee</th>
                  <th>Scope</th>
                  <th>Submitted</th>
                  <th>Review</th>
                  <th>P / F / B / NA</th>
                  <th>Pass Rate</th>
                  <th>Linked Tasks</th>
                  <th className="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? rows.map((row) => (
                  <tr key={`${row.form_submission_id}-${row.submission_revision}`}>
                    <td>
                      <strong>{row.form_name}</strong>
                      <div className="fer-version-pill">v{row.version_number}</div>
                    </td>
                    <td className="small">
                      <span className="fer-avatar" style={{ background: avatarColorFor(row.employee_name) }}>{initialsOf(row.employee_name)}</span>
                      {row.employee_name}
                      <ExternalRecipientBadge external={isExternalRecipient(row)} />
                    </td>
                    <td className="small fer-scope-cell">{row.project_name || "—"}{row.module_name ? ` / ${row.module_name}` : ""}</td>
                    <td className="small">{row.submitted_at ? new Date(row.submitted_at).toLocaleDateString() : "—"}</td>
                    <td>
                      {row.review_status ? (
                        <span className={`fer-review-pill fer-review-${REVIEW_TONE[row.review_status] || "secondary"}`}>
                          <i className="fer-review-dot" aria-hidden="true"></i>{row.review_status}
                        </span>
                      ) : <span className="text-muted small">—</span>}
                    </td>
                    <td className="small fer-pfbn">
                      <span className="fer-pfbn-item fer-pfbn-pass">{row.passed_test_cases}</span>
                      <span className="fer-pfbn-item fer-pfbn-fail">{row.failed_test_cases}</span>
                      <span className="fer-pfbn-item fer-pfbn-block">{row.blocked_test_cases}</span>
                      <span className="fer-pfbn-item fer-pfbn-na">{row.not_applicable_test_cases}</span>
                    </td>
                    <td className="small">
                      {row.pass_rate != null ? <strong>{row.pass_rate}%</strong> : "—"}
                      <div className="text-muted" style={{ fontSize: 11 }}>{row.completion_rate != null ? `${row.completion_rate}% complete` : ""}</div>
                    </td>
                    <td className="small">{row.active_linked_task_count} active / {row.linked_task_count} total</td>
                    <td className="text-end">
                      <Button size="sm" className="unit-btn unit-btn-light fer-view-btn" onClick={() => navigate(`/${rolePrefix}/form-submissions/${row.form_submission_id}`)}>
                        View
                      </Button>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="9">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-flask-vial" aria-hidden="true"></i>
                        </div>
                        <h5>No execution results found</h5>
                        <p>No test-execution-profiled submissions match the selected filters.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> item(s)</div>
          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      {showFailedCases && (
        <Card className="mt-3 fer-cases-card exec-failed-card">
          <Card.Body>
            <div className="exec-failed-card-title">
              <div className="exec-failed-card-icon">
                <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
              </div>

              <div>
                <strong>Failed / Blocked Test Cases</strong>
                <span>Current filters</span>
              </div>
            </div>
            {loadingFailedCases ? (
              <Spinner size="sm" animation="border" />
            ) : (
              <Table size="sm" responsive className="unit-table fer-cases-table">
                <thead>
                  <tr>
                    <th>Form</th><th>Employee</th><th>#</th><th>Test Case</th><th>Result</th><th>Severity</th><th>Expected</th><th>Actual</th><th className="exec-failed-actions-header">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {failedCases.map((row, i) => (
                    <tr key={`${row.form_submission_id}-${row.id}-${i}`}>
                      <td className="small">{row.form_name}</td>
                      <td className="small">
                        {row.employee_name}
                        <ExternalRecipientBadge external={isExternalRecipient(row)} />
                      </td>
                      <td>{row.row_number}</td>
                      <td className="small">{row.test_case_id || row.test_case_title || "—"}</td>
                      <td>
                        <span
                          className={`exec-failed-result-chip ${
                            row.result_status === "FAIL"
                              ? "exec-failed-result-fail"
                              : "exec-failed-result-blocked"
                          }`}
                        >
                          {row.result_status}
                        </span>
                      </td>
                      <td className="small">{row.severity || "—"}</td>
                      <td className="small" style={{ maxWidth: 160 }}>{row.expected_result || "—"}</td>
                      <td className="small" style={{ maxWidth: 160 }}>{row.actual_result || "—"}</td>
                      <td className="exec-failed-actions-cell">
                        <Button
                          className="exec-report-action-btn exec-report-action-view"
                          onClick={() =>
                            navigate(
                              `/${rolePrefix}/form-submissions/${row.form_submission_id}`
                            )
                          }
                          title="View Submission"
                          aria-label={`View ${row.form_name || "submission"}`}
                        >
                          <i className="fa-solid fa-eye" aria-hidden="true"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {!failedCases.length && <tr><td colSpan="9" className="text-muted small">No failed/blocked cases for the selected filters.</td></tr>}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      )}
    </div>
  );
}
